(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  /** EP-475 | Online Assessment | generate_lead event */
  document.addEventListener('DOMContentLoaded', () => {
    const DEBUG = false;

    const form = document.getElementById('contact-form');
    if (!form) return;

    const email = document.getElementById('00N2p000006x29z');
    if (!email) return;

    /* --- Show success message if redirected after form submission --- */
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('contact_form_submitted') === 'true') {
      form.style.display = 'none';
      const successDiv = document.getElementById('contact-form-success');
      if (successDiv) {
        successDiv.style.display = 'flex';
        successDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      /* Clean the URL parameter without reloading */
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      return;
    }

    form.addEventListener('submit', async (e) => {
      const hashedEmail = await window.digestMessageSHA256(email.value);
      const siteLocation = window.theme.siteLocation || undefined;
      const optinStatus = false; // Always false, this form do not generate option for marketing

      const event = {
        event: 'generate_lead',
        hashed_email: hashedEmail,
        site_location: siteLocation,
        contact_mode: 'form',
        contact_type: 'generic contact form',
        optin_status: optinStatus,
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(event);
      if (DEBUG) console.debug('DataLayer pushed:', event);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdl-main-register"]) return;
  try {
    
  CF.ready(function() {
    const DEBUG = false;
    const createCustomerForm = document.querySelector('form[id=create_customer]');
    if (DEBUG) console.debug('[Helium Customer Fields]', { createCustomerForm });
    if (!createCustomerForm) return;

    const emailInputParent = createCustomerForm.querySelector('.cf-field.custom_field_input[data-cf-field-type="email"]');
    const phoneInputParent = createCustomerForm.querySelector('.cf-field.custom_field_input[data-cf-field-type="phone"]');

    if (DEBUG) console.debug('[Helium Customer Fields]', { emailInputParent, phoneInputParent });
    if (!emailInputParent) return;

    const emailInput = emailInputParent.querySelector('input');
    const phoneInput = phoneInputParent?.querySelector('input');

    if (DEBUG) console.debug('[Helium Customer Fields]', { emailInput, phoneInput });
    if (!emailInput) return;

    function clearCustomErrors(fieldParent) {
      if (!fieldParent) return;
      const uls = fieldParent.querySelectorAll('ul.cf-field-errors[custom-error-message]');
      uls.forEach((ul) => ul.remove());
      fieldParent.removeAttribute('data-cf-invalid');
    }

    emailInput.addEventListener('focus', () => clearCustomErrors(emailInputParent));
    phoneInput?.addEventListener('focus', () => clearCustomErrors(phoneInputParent));

    function addMessage(fieldParent, msg) {
      if (!fieldParent) return;

      clearCustomErrors(fieldParent);
      fieldParent.setAttribute('data-cf-invalid', 'true');

      const div = document.createElement('div');
      div.setAttribute('data-reach-alert', 'true');
      div.innerText = Shopify.locale === 'it' ? msg.it : msg.en;

      const li = document.createElement('li');
      li.appendChild(div);

      const ul = document.createElement('ul');
      ul.classList.add('cf-field-errors');
      ul.setAttribute('custom-error-message', '');
      ul.appendChild(li);

      fieldParent.appendChild(ul);
    }

    createCustomerForm.addEventListener('cf:form_submitted', function (e) {
      e.preventDefault();
      if (DEBUG) console.debug('[Helium Customer Fields]', { e });

      const submissionData = e.detail.submissionData;
      if (DEBUG) console.debug('[Helium Customer Fields]', { submissionData });
      if (!submissionData) return;

      const email = submissionData.email;
      const emailMarketingConsent = submissionData.email_marketing_consent;

      if (DEBUG) console.debug('[Helium Customer Fields]', { email, emailMarketingConsent });
      if (!email || !emailMarketingConsent) return;

      const customEvent = new CustomEvent('newsletterFormSubmitted', {
        detail: {
          email,
          siteLocation: window.theme?.siteLocation
        }
      });

      if (DEBUG) console.debug('[Helium Customer Fields]', { customEvent });
      window.dispatchEvent(customEvent);
    });

    createCustomerForm.addEventListener('cf:form_submission_failed', function(e) {
      const emailHasAlreadyBeenTakenMsg = {
        en: 'This email is associated with another account. Please use a different one.',
        it: "L'indirizzo email è già associato a un altro account. Ti preghiamo di selezionarne un altro."
      };

      const phoneAlreadyTakenMsg = {
        en: 'This phone number is already associated with an account.',
        it: 'Questo numero di telefono è già associato a un account.'
      };

      const emailIsInvalidMsg = {
        en: 'Please, enter a valid e-mail.',
        it: "Per favore, inserisci un'email valida."
      };

      const errors = e.detail.errors || {};
      if (DEBUG) console.debug('[Helium Customer Fields]', { errors });

      const hasEmailError = 'email' in errors;
      const hasPhoneError = 'phone' in errors;

      if (!hasEmailError && !hasPhoneError) return;

      if (hasPhoneError) {
        const phoneErrors = Array.isArray(errors.phone) ? errors.phone.join(' ') : String(errors.phone);
        const hasPhoneAlreadyBeenTaken = phoneErrors.includes('has already been taken');

        if (DEBUG && hasPhoneAlreadyBeenTaken) {
          console.debug('[Helium Customer Fields]', 'Phone has already been taken');
        }

        if (hasPhoneAlreadyBeenTaken) {
          addMessage(phoneInputParent, phoneAlreadyTakenMsg);
        }
      }

      if (hasEmailError) {
        const emailErrors = Array.isArray(errors.email) ? errors.email.join(' ') : String(errors.email);
        const hasEmailAlreadyBeenTaken = emailErrors.includes('has already been taken');
        const isEmailInvalid = emailErrors.includes('is invalid');

        if (DEBUG && hasEmailAlreadyBeenTaken) {
          console.debug('[Helium Customer Fields]', 'Email has already been taken');
        }

        if (DEBUG && isEmailInvalid) {
          console.debug('[Helium Customer Fields]', 'Email is invalid');
        }

        if (hasEmailAlreadyBeenTaken) {
          addMessage(emailInputParent, emailHasAlreadyBeenTakenMsg);
        }

        if (isEmailInvalid) {
          addMessage(emailInputParent, emailIsInvalidMsg);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
